var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMidForeground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 202.69 144.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ff74ab78-7ab3-44f0-853e-6fb5f2f0f93f{fill:#815aaf;}.bc9f1fbf-c2be-42de-bec1-4563c0fffa5e{fill:#ad7fd8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b892cf42-38f7-44bb-889e-3bd15d3dc939",
    "data-name": "CIRCUIT FINAL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ff74ab78-7ab3-44f0-853e-6fb5f2f0f93f",
    d: "M137.3,60.18l-25.87,15c-5.47,3.18-14.37,3.18-19.88,0l-26-15c-2.77-1.61-4.16-3.71-4.15-5.8L61.3,72.87c0,2.1,1.38,4.2,4.16,5.8l26,15c5.51,3.18,14.42,3.18,19.89,0l25.87-15C140,77.09,141.33,75,141.34,73l0-18.49C141.38,56.53,140,58.59,137.3,60.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc9f1fbf-c2be-42de-bec1-4563c0fffa5e",
    d: "M137.24,48.66l-5.13-3,0,7.19c0,1.59-1.06,3.18-3.15,4.4L109.06,68.83a16.86,16.86,0,0,1-15.28,0l-20-11.56c-2.13-1.23-3.19-2.84-3.19-4.45l0-7.16-5.15,3C60,51.84,60,57,65.51,60.18l26,15c5.51,3.18,14.41,3.18,19.88,0l25.87-15C142.78,57,142.75,51.84,137.24,48.66Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidForeground);
export default __webpack_public_path__ + "static/media/mid-foreground.e8dd22ef.svg";
export { ForwardRef as ReactComponent };